import { useState } from "react";
import { ArrowLeft, ArrowRight, ArrowUpRight, Mail, MapPin, Phone } from "lucide-react";
import { alumniOfficers, campusPhotos, collegeContacts } from "../data/content";

export default function College() {
  const [photo, setPhoto] = useState(0);
  const move = (direction) => setPhoto((value) => (value + direction + campusPhotos.length) % campusPhotos.length);

  return (
    <>
      <section className="college-hero">
        <img src="/media/college/campus-03.webp" alt="Mar Athanasius College of Engineering campus" />
        <div className="college-hero__wash" />
        <div className="college-hero__copy section-wrap">
          <p className="kicker">Kothamangalam · Since 1961</p>
          <h1>The place<br />that made us.</h1>
          <p>MACE is autonomous, affiliated with APJ Abdul Kalam Technological University, and still rooted in the green campus the class remembers.</p>
          <a className="button button--cream" href={collegeContacts.website} target="_blank" rel="noreferrer">Visit the official college website <ArrowUpRight aria-hidden="true" /></a>
        </div>
      </section>

      <section className="college-about section-wrap">
        <div className="section-heading"><p className="kicker">Alma mater, today</p><h2>A direct line back to campus.</h2></div>
        <div className="college-about__body">
          <p className="dropcap">The MACE Alumni Association now connects twenty-three active chapters in India and abroad. Its campus centre includes guest rooms, conference space, a seminar hall, training and placement functions, and a business incubation centre.</p>
          <p>Use the verified contacts below for alumni matters, campus visits, and official college questions. Details were checked against the official MACE pages on {collegeContacts.verified}.</p>
          <div className="college-about__links">
            <a href={collegeContacts.alumniWebsite} target="_blank" rel="noreferrer">Official alumni page <ArrowUpRight aria-hidden="true" /></a>
            <a href={collegeContacts.alumniCommunity} target="_blank" rel="noreferrer">MACE alumni community <ArrowUpRight aria-hidden="true" /></a>
          </div>
        </div>
      </section>

      <section className="officers section-wrap">
        <div className="section-heading"><p className="kicker">Current office bearers</p><h2>MACE Alumni Association</h2></div>
        <div className="officer-list">
          {alumniOfficers.map((officer, index) => (
            <article className="officer" key={officer.role}>
              <span className="officer__number">0{index + 1}</span>
              <img src={officer.image} alt={`Portrait of ${officer.name}`} />
              <div><p className="kicker">{officer.role}</p><h3>{officer.name}</h3>{officer.detail && <span>{officer.detail}</span>}</div>
              <div className="officer__contact"><a href={`tel:${officer.phone.replace(/\s/g, "")}`}><Phone aria-hidden="true" /> {officer.phone}</a><a href={`mailto:${officer.email}`}><Mail aria-hidden="true" /> {officer.email}</a></div>
            </article>
          ))}
        </div>
      </section>

      <section className="campus-stage section-wrap">
        <div className="campus-stage__heading"><div><p className="kicker">The campus now</p><h2>Still unmistakably MACE.</h2></div><a href="https://mace.ac.in/about/images/" target="_blank" rel="noreferrer">Official gallery <ArrowUpRight aria-hidden="true" /></a></div>
        <figure>
          <img src={campusPhotos[photo].src} alt={campusPhotos[photo].alt} />
          <figcaption><span>{String(photo + 1).padStart(2, "0")} / {String(campusPhotos.length).padStart(2, "0")}</span><p>{campusPhotos[photo].alt}</p></figcaption>
          <button className="photo-stage__arrow is-left" type="button" onClick={() => move(-1)} aria-label="Previous campus photograph"><ArrowLeft aria-hidden="true" /></button>
          <button className="photo-stage__arrow is-right" type="button" onClick={() => move(1)} aria-label="Next campus photograph"><ArrowRight aria-hidden="true" /></button>
        </figure>
        <p className="source-note">Campus photographs © Mar Athanasius College of Engineering, presented from the official college gallery.</p>
      </section>

      <section className="contact-block">
        <div className="section-wrap contact-block__inner">
          <div><p className="kicker">Contact the college</p><h2>Start with the office.</h2></div>
          <div className="contact-block__details">
            <p><MapPin aria-hidden="true" /> {collegeContacts.address}</p>
            <p><Phone aria-hidden="true" /> {collegeContacts.phones.join(" · ")}</p>
            <a href={`mailto:${collegeContacts.email}`}><Mail aria-hidden="true" /> {collegeContacts.email}</a>
          </div>
        </div>
      </section>
    </>
  );
}
